import React from "react";
import { Container, Spinner } from "../../ui";
import "./PageSkeleton.style.scss";

export const PageSkeleton = () => (
    <Container className="page-skeleton-container">
        <Spinner visible={true} />
    </Container>
);
